import Util from "../util/Util.js";
import V1Router from "../v1/LoginRouter.js";
import WidgetRouter from "../v2/WidgetRouter.js";
function routerClassFactory(options) {
  let Router;
  const v1DefaultFlow = !options.stateToken && !options.clientId && !options.proxyIdxResponse;
  const v1StateTokenFlow = options.stateToken && Util.isV1StateToken(options.stateToken);
  const v1AuthFlow = options.clientId && options.useClassicEngine === true;
  if (v1DefaultFlow || v1StateTokenFlow || v1AuthFlow) {
    Router = V1Router;
  } else {
    Router = WidgetRouter;
  }
  return Router;
}
export { routerClassFactory };
